import { lazy } from 'react'
import suspenseComponent from '../../util/suspenseComponent'

let ColorPicker = lazy(() => import('./ColorPicker'))
ColorPicker = suspenseComponent(ColorPicker)

export default ColorPicker
